import { arrayOf, string, shape, bool, oneOf } from "prop-types";
import cx from "classnames";

const link = {
  href: string.isRequired,
  label: string.isRequired,
  active: bool,
};

const navTitles = shape({
  primary: string.isRequired,
  auxiliary: string.isRequired,
});

const propTypes = {
  className: string,
  linkSize: oneOf(["big"]), // small is the default
  primaryLinks: arrayOf(shape(link)),
  auxiliaryLinks: arrayOf(shape(link)),
  auxiliaryBorder: bool,
  navTitles: navTitles,
};

const NarrativeLinks = (props) => {
  const {
    primaryLinks,
    auxiliaryLinks,
    linkSize,
    className,
    navTitles,
    auxiliaryBorder,
  } = props;

  return (
    <section
      className={cx("narrative-links", className, {
        "narrative-links--with-nav-titles": navTitles,
        "narrative-links--big": linkSize === "big",
      })}
    >
      <div className={cx("narrative-links__primary-nav")}>
        {navTitles && (
          <h2 className="narrative-links__primary-link-title title--eyebrow">
            {navTitles.primary}
          </h2>
        )}
        <nav aria-label="section links">
          <ul>
            {primaryLinks &&
              primaryLinks.map((link, index, arr) => (
                <li key={link.href}>
                  <a
                    className={cx("narrative-links__primary-link arrow-link", {
                      "narrative-links__primary-link--active": link.active,
                    })}
                    href={link.href}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
          </ul>
        </nav>
      </div>
      <div
        className={cx("narrative-links__auxiliary-nav", {
          "narrative-links__auxiliary-nav--border": auxiliaryBorder,
        })}
      >
        {navTitles && (
          <h2 className="narrative-links__auxiliary-link-title title--eyebrow">
            {navTitles.auxiliary}
          </h2>
        )}
        <nav aria-label="appendix links">
          <ul>
            {auxiliaryLinks &&
              auxiliaryLinks.map((link, index, arr) => (
                <li key={link.href}>
                  <a
                    className={cx("narrative-links__auxiliary-link", {
                      "narrative-links__auxiliary-link--active": link.active,
                    })}
                    href={link.href}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
          </ul>
        </nav>
      </div>
    </section>
  );
};

NarrativeLinks.propTypes = propTypes;
export default NarrativeLinks;
